"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./Link.css");
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link(props) {
        var _this = _super.call(this, props) || this;
        _this.targetWindow = null;
        _this.targetURL = 'javascript:void(0)';
        _this.onLinkClick = _this.onLinkClick.bind(_this);
        _this.setAnchorAttribute();
        return _this;
    }
    Link.prototype.setAnchorAttribute = function () {
        if (this.props.data && this.props.data.target) {
            this.targetWindow = this.props.data.target;
        }
        if (this.props.data && this.props.data.href) {
            this.targetURL = this.props.data.href;
        }
    };
    Link.prototype.render = function () {
        var classes = [
            this.props.options.className,
            styles.linkCta,
        ];
        return (React.createElement("span", { "data-test-id": this.props.testId, className: classes.join(' ') },
            React.createElement("a", { onClick: this.onLinkClick, href: this.targetURL, target: this.targetWindow, className: styles.linkCta, "aria-label": this.ariaLabelContent, rel: "noopener", role: "link", title: this.props.title },
                this.props.data.content,
                this.props.children ? this.props.children : null)));
    };
    Link.prototype.onLinkClick = function (e) {
        if (this.props.events) {
            this.props.events.onClick();
        }
    };
    Object.defineProperty(Link.prototype, "ariaLabelContent", {
        // private get ariaLabelContent() {
        //   return `${this.props.options.accessibility || ''}, ${this.props.data.content}`;
        // }
        get: function () {
            return this.props.options.accessibility ?
                (this.props.options.accessibility + ',' || '') + " " + this.props.data.content
                : "" + this.props.data.content;
        },
        enumerable: false,
        configurable: true
    });
    Link.defaultProps = {
        className: '',
        options: {},
    };
    return Link;
}(React.Component));
exports.default = Link;
//# sourceMappingURL=Link.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Link/Link.js
// module id = 1178
// module chunks = 8